import React from 'react';
import {
    Row,
    Col,
    Divider,
    Typography,
    Tabs,
    Skeleton,
    Result,
} from 'antd';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import StudentForm from './components/StudentForm';
import ParentForm from './components/ParentForm';

export default function Edit() {

    const { id } = useParams();
    const student = useQuery({ queryKey: [`/api/students/${id}`] })

    if (student.isLoading) {
        return <Skeleton active />
    }

    if (student.errorisError) {
        return <Result status="error" title={student.error.message} />
    };

    // console.log("id: ", id);
    // console.log("shipment: ", shipment.data);
    // console.log("student: ", student.data);
    // console.log("rawProvince: ", rawProvince);
    // console.log("dayjs(customer.data.birth_date): ", dayjs(customer.data.birth_date).isValid());
    return (
        <div style={{
            background: '#fff',
        }}>
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        {`Student ID : ${student.data.student_code}`}
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    <Tabs
                        type="card"
                        defaultActiveKey="1"
                        items={[
                            {
                                key: 'student',
                                label: 'Student',
                                children: <StudentForm student={student.data} />,
                            },
                            {
                                key: 'parent',
                                label: 'Parent',
                                children: <ParentForm parent={student.data.parent} />,
                            },

                        ]}
                    />
                </Col>
            </Row>
        </div>
    )
}
